import { useMemo } from "react";

import { InfoOutlined as InfoIcon } from "@mui/icons-material";
import { Box, Chip, Stack, Tooltip, Typography } from "@mui/material";

const replaceTokensWithChips = (inputString: string, tokens: string[]): React.ReactNode[] => {
  const tokenPattern = new RegExp(`\\b(${tokens.join("|")})\\b`, "g");

  const parts = inputString.split(tokenPattern);

  return parts.map((part: string, index: number) => {
    if (tokens.includes(part)) {
      return <Chip key={index} label={part} sx={{ margin: "2px", fontWeight: 500 }} />;
    }
    return (
      <Typography
        key={index}
        variant="body2"
        component="span"
        sx={{
          fontWeight: 500,
          wordBreak: "break-word",
          fontSize: "0.875rem",
        }}
      >
        {part}
      </Typography>
    );
  });
};

const AllocationLogic = ({ formula, tokens }) => {
  const renderedFormula = useMemo(() => replaceTokensWithChips(formula, tokens), [formula, tokens]);
  return (
    <Stack>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          Allocation logic
        </Typography>
        <Tooltip title="Information about allocation logic" arrow placement="right">
          <InfoIcon sx={{ fontSize: 16, color: "text.secondary" }} />
        </Tooltip>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: 0.5,
          flexWrap: "wrap",
        }}
      >
        {renderedFormula}
      </Box>
    </Stack>
  );
};

export default AllocationLogic;
